const utils = require('../../../lib/utils')

module.exports = {
	config: {
		registerSecret: 'imageList',
		registerType: 'component',
		forceDomUpdate: 10,
		imageTemplate: '../../../base/form/media/image/image',
		maxImageWidth: 100,
		maxImageHeight: 100,
		elementWidth: 140,
		elementHeight: 122,
		environmentDependent: true,
	},

	model: {
		mediaList: {},
		selectedMedia: {},
		selectedMediaIndex: 0,

		configsInitialized: false,
		fieldConfig: {},
		managementConfig: {},
		listOfMediaIDs: null,
		showNonReusablesAsWell: false,

		lazyloadStepSize: 63, // 9 images * 7 rows
		lazyloadingInEffect: false,
		nrOfElements: {
			nrOfElements: 0,
			nrOfMatchingElements: 0,
			nrOfNonMatchingElements: 0
		}
	},

	events: {
		selectImage: {
			type: 'click',
			action: function (event) {
				event.preventDefault()
				event.stopImmediatePropagation()
				var $target
				var mediaID = ($target = $(event.target).closest('.base_form_media_image_image')).data('mediaId')
				var mediaKey
				if(mediaID){
					utils.performButtonAction(event, undefined, { mediaID: mediaID }).then(function(context){
						var self = event.data.component
						if(!context.actionPerformed){
							// deselect image
							if($target.hasClass('selected')){
								$target.removeClass('selected')
								event.data.component.model.selectedMedia[mediaID] = -1
							}
							else {
								// prepare
								var managementConfig    = self.model.managementConfig
								if(managementConfig.multiSelect !== false && managementConfig.maxNrOfElements <= 1){
									managementConfig.multiSelect = false
								}

								// deselect all => multi selection not allowed
								if(managementConfig.multiSelect === false){
									if(utils.collectionSize(self.model.selectedMedia) > 0){
										self.$.find('[data-media-id="' + Object.keys(self.model.selectedMedia).join('"],[data-media-id="') + '"]').removeClass('selected')
										self.model.selectedMedia = {}
										self.model.selectedMediaIndex = 0
									}
								}
								// deselect selected images until maxNrOfElements-limit is not violated any longer if necessary starting with the earliest selection.
								else if(managementConfig.maxNrOfElements > 1 && self.model.selectedMediaIndex >= managementConfig.maxNrOfElements){
									var minMediaIndex = (self.model.selectedMediaIndex - managementConfig.maxNrOfElements + 1)
									for(var selectedMediaID in self.model.selectedMedia){
										if(self.model.selectedMedia[selectedMediaID] < minMediaIndex){
											delete self.model.selectedMedia[selectedMediaID]
											self.$.find('[data-media-id="' + selectedMediaID + '"]').removeClass('selected')
										}
									}
								}

								// check if image dimensions are sufficient
								mediaKey = 'mediaID_' + mediaID
								var imageData = self.model.mediaList[mediaKey]
								if(
									(
										imageData.width > 0
										&&
										imageData.width < (self.model.maxImageDimensions || {}).width || 0
									)
									||
									(
										imageData.height > 0
										&&
										imageData.height < (self.model.maxImageDimensions || {}).height || 0
									)
								){
									self.performDecision(
										'confirm',
										{
											component:  self,
											mediaID:    mediaID,
											title:      storage.__('error:imageManagement.tooSmallImageSelected.title'),
											message:    storage.__('error:imageManagement.tooSmallImageSelected.message', { max: self.model.maxImageDimensions, image: { width: imageData.width, height: imageData.height }})
										}
									).then(function(context){
										if(context.decision.type === 'yes'){
											// select image
											$target.addClass('selected')
											context.scope.component.model.selectedMedia[context.scope.mediaID] = context.scope.component.model.selectedMediaIndex++
										}
									})
								}
								else {
									// select image
									$target.addClass('selected')
									event.data.component.model.selectedMedia[mediaID] = event.data.component.model.selectedMediaIndex++
								}
							}
						}

						self.updateNrOfElements()
					})
				}
			}
		},

		showImageDetailsSummary: {
			type: 'mouseenter',
			selector: '.base_form_media_image_image',
			action: function(event){
				var self = event.data.component
				var $target = $(event.target).closest('.base_form_media_image_image')
				if($target.length > 0){
					var mediaID = $target.data('mediaId')
					if(mediaID){
						var media = self.getMediaByID(mediaID)
						if(Object.keys(media).length > 0){
							self.triggerClosest('showMediaDetails', { media })
						}
					}
				}
			}
		},

		lazyloadClick: {
			type: 'click',
			selector: 'button[data-field-type="lazyload"]',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()
				event.data.component.lazyloadNext()
			}
		},

		lazyloadScroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				event.data.component.onScrollLazyload($(event.target).closest('section.content'), event.data.component.$)
			}
		}
	},

	methods: {
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this
			if(additionalData.mediaID){
				var $target = self.$.find('[data-media-id="' + additionalData.mediaID + '"]').addClass('deletionInProgress')
				var messageBaseName = 'hint.delete.really.media'
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__(messageBaseName + '.title'),
						message:    storage.__(messageBaseName + '.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(
							self.prepareAction('deleteMedia', additionalData.mediaID)
						).then(function(context){
							$target.addClass('deleted')
							delete self.model.mediaList['mediaID_' + additionalData.mediaID]
							self.model.selectedMedia[additionalData.mediaID] = -1
							if(self.model.$newImageList.find('[data-media-id]:not(.deleted)').length === 0){
								self.model.$newImageContainer.removeClass('active')
							}
							self.updateNrOfElements()
						}).fail(function(error){
							$target.removeClass('deletionInProgress')
						})
					} else {
						$target.removeClass('deletionInProgress')
					}
				})
			}
		},

		initConfigs(){
			if(!this.model.configsInitialized){
				this.model.configsInitialized 	    = true
				this.model.fieldConfig              = this.getResourceRegisterContent('fieldConfig') || {};
				this.model.managementConfig         = this.model.fieldConfig.managementConfig || {};
				this.model.listOfMediaIDs 		    = this.getResourceRegisterContent('listOfMediaIDs') || [];
				this.model.showNonReusablesAsWell	= utils.isEmpty(this.model.fieldConfig); // if mediaManagement gets opened via main nav entry without any field context non-reusables should be displayed as well.
			}
		},

		dataDealer: function(){
			const storage = this.getStorage() || {}
			const activeMediaConfig = (((storage.app || {}).webService || {}).config || {}).media || {};

			this.initConfigs()
			this.model.maxImageDimensions   = utils.media.image.detectMaxDimensions(this.model.fieldConfig, activeMediaConfig);
		},

		prepare: function(storage){
			const user = (storage || {}).user
			if(user) 	this.model.extendedButtonActionsGranted = user.hasAccessTo('usage:media:extendedButtonActions', this.scope);
			else 		this.model.extendedButtonActionsGranted = false;
		},

		sanitizeResources: function(storage){

			if(!this.config.isReady){
				this.model.mediaList = {}
			}

			var self 		= this
			var mediaList 	= this.model.mediaList
			var mediaKey
			var domImagePresent
			if(self.resourceData && self.resourceData.data && (!self.resourceData.initialized || self.model.lazyloadingInEffect)){
				self.resourceData.initialized = true
				utils.forEach(self.resourceData.data, function(image){
					self.prepareImageData(image, storage)
					// this key is necessary to prevent order issues
					mediaKey = 'mediaID_' + image.mediaID
					domImagePresent = self.model.lazyloadingInEffect && mediaList[mediaKey] && mediaList[mediaKey] !== -1
					delete mediaList[mediaKey]
					mediaList[mediaKey] = image
					// add lazyloaded images if necessary
					if(self.config.isReady && !domImagePresent){
						self.addImage(image, false)
					}
				})
				self.updateNrOfElements()
			}
			// filters may be too restrictive
			else if(storage.isClient){
				self.updateNrOfElements()
			}
		},

		getResourceFilters: function(){
			this.initConfigs()
			if(!this.model.resourceFilters) this.model.resourceFilters = {}
			const filters = this.model.resourceFilters
			filters.listOfMediaIDs = this.model.listOfMediaIDs
			filters.permissionsGrantedOnly = !this.hasAccessTo(`cms_media:permissions:mimicOwner`)
			filters.ownerOnly = (this.model.managementConfig || {}).ownerOnly
			if(!this.model.showNonReusablesAsWell) 	filters.isReusable = true;
			if(!this.config.isReady) 				filters.offset = 0;
			if(!filters.offset) 					filters.offset = 0;
			if(!filters.limit) 						filters.limit = filters.offset + (this.model.lazyloadStepSize || 0);

			// FILTER EXAMPLES:
			// filters.listOfCategoryDataIDs = [2];
			// filters.order = 'sizeInBytes';
			// filters.order = [{ field: 'originalName', direction: 'DESC' }];

			return filters
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			const nrOfOrderFilters = utils.collectionSize((resourceFilters || {}).order)
			return actionKey !== 'refreshResources' || nrOfOrderFilters > 1
		},

		setFilter: function(field, value){
			if(!this.model.resourceFilters) this.model.resourceFilters = {}
			if(field) this.model.resourceFilters[field] = value;
			this.model.resourceFilters.offset = 0
			this.model.resourceFilters.limit = this.model.lazyloadStepSize
			this.model.mediaList = {}
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			this.refresh()
		},

		updateFilters: function(filters){
			utils.refReplace(this.model.resourceFilters, filters)
			this.setFilter()
		},

		onScrollLazyload($scrollContainer, $fullHeightContainer){
			this.delayedLastOf('onScrollLazyload', () => {
				if(
					$scrollContainer.length > 0 &&
					$fullHeightContainer.length > 0 &&
					($fullHeightContainer.height() - $scrollContainer.height() - $scrollContainer.scrollTop()) <= 50
				){
					this.lazyloadNext()
				}
			}, 100)
		},

		lazyloadNext: function(oldLazyloadStepSize = 0){
			var self = this
			// prevent lazyloading requests if the last lazyload contained no data
			if(!self.model.lazyloadingInEffect && (self.resourceData.data || []).length > 0){
				self.model.lazyloadingInEffect = true
				// load missing piece of last batch if necessary
				if(oldLazyloadStepSize > 0){
					self.model.resourceFilters.offset += oldLazyloadStepSize
					if(oldLazyloadStepSize < self.model.lazyloadStepSize){
						self.model.resourceFilters.limit = self.model.lazyloadStepSize - oldLazyloadStepSize
					}
				} else {
					self.model.resourceFilters.offset += self.model.lazyloadStepSize
				}
				self.performAction('refreshResources')
					.always(function(){
						self.model.lazyloadingInEffect = false
						// reset offset and limit after loading missing piece of last batch if necessary
						if(oldLazyloadStepSize > 0){
							self.model.resourceFilters.offset -= oldLazyloadStepSize;

							if(oldLazyloadStepSize < self.model.lazyloadStepSize){
								self.model.resourceFilters.limit = self.model.lazyloadStepSize
							}
						}
					})
				;
			}
		},

		updateLazyloadStepSize(){
			const $container = this.model.$imageList.closest('section.content')

			const nrOfElements = {
				x: Math.floor(($container.width() || 0) / (this.config.elementWidth || 140)),
				y: Math.ceil(($container.height() || 0) / (this.config.elementHeight || 122)),
			}

			const newLazyLoadStepSize = Math.max(nrOfElements.x * nrOfElements.y, this.model.lazyloadStepSize || 63);
			if(this.model.lazyloadStepSize < newLazyLoadStepSize){
				const oldLazyLoadStepSize = this.model.lazyloadStepSize;
				this.model.lazyloadStepSize = newLazyLoadStepSize
				if(utils.collectionSize(this.model.mediaList) < newLazyLoadStepSize){
					this.lazyloadNext(oldLazyLoadStepSize)
				}
			}
		},

		selectAllMedia: function(){
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			for(var m in this.model.mediaList){
				this.model.selectedMedia[this.model.mediaList[m].mediaID] = this.model.selectedMediaIndex++
			}
			this.$.find('.base_form_media_image_image').addClass('selected')
			this.updateNrOfElements()
		},

		deselectAllMedia: function(){
			this.model.selectedMedia = {}
			this.model.selectedMediaIndex = 0
			this.$.find('.base_form_media_image_image').removeClass('selected')
			this.updateNrOfElements()
		},

		getSelectedMedia: function(){
			var self = this
			var selectedMedia = {}
			var mediaKey
			utils.forEach(self.model.selectedMedia, function(sortIndex, mediaID){
				mediaKey = 'mediaID_' + mediaID
				if(sortIndex >= 0 && self.model.mediaList[mediaKey]){
					selectedMedia[sortIndex] = self.model.mediaList[mediaKey]
				}
			})
			return selectedMedia
		},

		getMediaByID: function(mediaID){
			if(mediaID && this.model.mediaList['mediaID_' + mediaID]){
				return this.model.mediaList['mediaID_' + mediaID]
			}
			return {}
		},

		updateMediaTagsByMediaID: function(mediaData){
			var mediaID, mediaKey, storage = this.getStorage()
			for(var m in mediaData || []){
				this.prepareImageData(mediaData[m], storage)
				mediaID = mediaData[m].mediaID
				mediaKey = 'mediaID_' + mediaID
				if(this.model.mediaList[mediaKey]){
					this.model.mediaList[mediaKey].tags 			= mediaData[m].tags
					this.model.mediaList[mediaKey].tagsResources 	= mediaData[m].tagsResources
				}
			}
		},

		prepareImageData: function(image, storage){
			utils.media.image.prepare(image, storage, 'web', this.scope)
		},

		addNewImage: function(image, prepend){
			image = image || {}
			var mediaList 	= this.model.mediaList
			var _primaryKey = image.primaryKey || 'mediaID'
			var primaryKey 	= image[_primaryKey]
			var mediaKey
			if(primaryKey){
				// this key is necessary to prevent order issues
				mediaKey = 'mediaID_' + primaryKey
				delete mediaList[mediaKey]
				mediaList[mediaKey] = image
				this.addImage(image, prepend, true)
				this.updateNrOfElements()
			} else {
				throw new Error('IMAGE-LIST MISSES THE PRIMARY KEY OF THE NEW IMAGE')
			}
		},

		addImage: function(image, prepend, newImage){
			// add image to dom if necessary
			if(this.config.isReady){
				var newImageTag = this.include(this.config.imageTemplate, { resourceData: image, config: { context: 'management', controls: this.config.imageControls || {} }, model: { extendedButtonActionsGranted: this.model.extendedButtonActionsGranted, maxImageWidth: this.config.maxImageWidth, maxImageHeight: this.config.maxImageHeight } })
				if(newImage){
					this.model.$newImageContainer.addClass('active')
					if(prepend) this.model.$newImageList.prepend(newImageTag)
					else        this.model.$newImageList.append(newImageTag)
				} else {
					if(prepend) this.model.$imageList.prepend(newImageTag)
					else        this.model.$imageList.append(newImageTag)
				}
			}
		},

		handleError: function(context){
			if(context.action.originalActionKey === 'deleteMedia' && context.error.errorCode === 'USER_PROVIDER_ROUTE_PRIVILEGE_ERROR' && context.error.statusCode === 403){
				return this.performAction(this.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:notAllowed.media.delete'
					}
				}))
			}

			context.errorUnhandled = true
			return utils.promise.resolve(context)
		},

		updateNrOfElements: function(){
			var nrOfElements = ((this.resourceData.nrOfElements || {}).data || {}).attributes || {}
			nrOfElements.nrOfShownElements = 0
			nrOfElements.sizeOfShownElements = 0
			nrOfElements.nrOfSelectedElements = 0
			nrOfElements.sizeOfSelectedElements = 0
			var mediaID, mediaKey
			for(mediaID in this.model.selectedMedia){
				if(this.model.selectedMedia[mediaID] !== -1){
					nrOfElements.sizeOfSelectedElements += (this.model.mediaList[`mediaID_${mediaID}`] || {}).sizeInBytes || 0
					nrOfElements.nrOfSelectedElements++
				}
			}
			for(mediaKey in this.model.mediaList){
				nrOfElements.nrOfShownElements++
				nrOfElements.sizeOfShownElements += (this.model.mediaList[mediaKey] || {}).sizeInBytes || 0
			}
			this.triggerClosest('updateNrOfElements', { nrOfElements })
		},

		/**
		 * environment has been updated (resize)
		 */
		onEnvironmentUpdated: function(){
			this.updateLazyloadStepSize()
		},
	},

	hooks: {
		modalAttached: function($element, options){
			this.updateLazyloadStepSize()
		},

		initFileList: function($element, options){
			utils.forEach(this.model.mediaList, image =>{
				this.addImage(image, false)
			})
		},

		attach: function($element, options){
			this.model.$imageList 			= $element.find('.imageList')
			this.model.$newImageContainer 	= $element.find('.newImages')
			this.model.$newImageList 		= $element.find('.newImageList')
			if(!utils.isEmpty(this.model.mediaList)){
				// NOTE: init files after the init process has been completed to prevent long gui-idle-times
				this.triggerWhenReady('initFileList', {})
			}

			if(options.refresh){
				$element.closest('section.content').scrollTop(0)
			}
		},
	}
}